import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";



export const getEncabezadoPartidas = async(dates) =>{
    const result = await PrivateInterceptor('Finanzas/RegistroContable/LibroDiario/EncabezadoPorFechas','POST' ,{FechaInicio: dates[0],FechaFinal: dates[1] })
    return result
}

export const getDetallesPartidas = async(dates) =>{
    const result = await PrivateInterceptor('Finanzas/RegistroContable/LibroDiario/DetallesPorFechas','POST' ,{FechaInicio: dates[0],FechaFinal: dates[1] })
    return result
}

export const getEncabezadoPorId = async(IdPartida) =>{
    const result = await PrivateInterceptor('Finanzas/RegistroContable/LibroDiario/EncabezadoPorId','POST' ,{IdPartida })
    return result
}

export const getDetallesPorId = async(IdPartida) =>{
    const result = await PrivateInterceptor('Finanzas/RegistroContable/LibroDiario/DetallesPorId','POST' ,{IdPartida })
    return result
}

export const obtenerNoPartida = async() =>{
    const result = await PrivateInterceptor('Finanzas/RegistroContable/LibroDiario/obtenerNoPartida','GET')
    return result
}

export const GuardarPartida = async (data, data2) => {
    const respuesta = PrivateInterceptor("Finanzas/RegistroContable/LibroDiario/GuardarPartida", "POST",{Encabezado: data, Detalle: data2});
    return respuesta;
};

export const EditarPartida = async (Encabezado, Detalle) => {
    const respuesta = PrivateInterceptor("Finanzas/RegistroContable/LibroDiario/EditarPartida", "POST",{Encabezado, Detalle});
    return respuesta;
};

export const postEstadoDetalles = async(datos) =>{
    const result = await PrivateInterceptor(`Finanzas/RegistroContable/LibroDiario/CambiarEstadoDetalles`, 'POST', {datos})
    return result;
}
